// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"TV-z","inlineTitle":"UV-z","sponsoredAdsWrapper":"VV-z","marketplaceRecosWrapper":"WV-z"};